import React from "react";
import { useTranslation } from "react-i18next";

import { getDaysTexts } from "../utils";
import { Week } from "../week";
import { TimeView } from "../weeklyView/timeView";
import { Props } from "./types";
import styles from "./styles.scss";

function DailyView({
  date,
  week,
  events,
  milestones,
  unavailabilities,
  calendarsHolidays,
  tasks,
  filter,
}: Props) {
  const { t } = useTranslation();
  const daysNames = getDaysTexts(t);

  return (
    <div className={styles.dailyView}>
      <div className={styles.labels}>
        {daysNames.map((name, i) => (
          <h3 key={i} className={styles.dayName}>
            {name}
          </h3>
        ))}
      </div>
      <Week
        week={week}
        filter={filter}
        events={events}
        unavailabilities={unavailabilities}
        milestones={milestones}
        calendarsHolidays={calendarsHolidays}
        tasks={tasks}
        selectedDate={date}
      />
      <TimeView
        week={[date]}
        filter={filter}
        events={events}
        tasks={tasks}
        unavailabilities={unavailabilities}
      />
    </div>
  );
}

export { DailyView };
